import { Box, makeStyles, Grid, Typography } from "@material-ui/core";

import { COLORS } from "../../theme/colors";

const useStyles = makeStyles(() => ({
  graphItem: {
    display: "flex",
    alignItems: "baseline",
    "&:not(:last-child)": {
      marginRight: 15,
    },
  },
  graphItemBox: {
    width: 8,
    height: 8,
    marginRight: 4,
  },
}));

export const defaultItems = [
  {
    name: "In this building",
    color: COLORS.blue,
  },
  {
    name: "Avg. portfolio",
    color: COLORS.spanishGray,
  },
  {
    name: "Avg. Industry",
    color: COLORS.darks[0][100],
  },
];

export const complexItems = [
  {
    name: "In this complex",
    color: COLORS.blue,
  },
  {
    name: "Avg. portfolio",
    color: COLORS.spanishGray,
  },
  {
    name: "Avg. Industry",
    color: COLORS.darks[0][100],
  },
];

export const allBuildingsItems = [
  {
    name: "Avg. portfolio",
    color: COLORS.spanishGray,
  },
  {
    name: "Avg. Industry",
    color: COLORS.darks[0][100],
  },
];

export const GraphFooter = ({ items, style, typographyStyle }) => {
  const classes = useStyles();

  return (
    <Grid container justifyContent="center" style={{ marginTop: 26, ...style }}>
      {(items || defaultItems).map((item, i) => (
        <Box key={i} className={classes.graphItem}>
          <Box className={classes.graphItemBox} style={{ backgroundColor: item.color }}></Box>
          <Box>
            <Typography style={typographyStyle}>{item.name}</Typography>
            <Typography style={{ ...typographyStyle, marginTop: -4 }}>{item.suffix}</Typography>
          </Box>
        </Box>
      ))}
    </Grid>
  );
};
